import React, { useState } from 'react';
import { Input, Label, Modal } from 'reactstrap';
import modalclose from '../../../images/close1.png';
import './index.css';

const PartiallyAcceptOrderConfirmModal = ({
  isOpen,
  toggle,
  orderData,
  accept,
}) => {
  const [number, setNumber] = useState(null);
  const [selectedOption, setSelectedOption] = useState('Credit limit exceeded');
  const [otherReason, setOtherReason] = useState('');

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      id="RejectOrderConfirmModal"
    >
      <div className="modalHeader mb-0">
        <div className="title">Partially Accept</div>
        <div className="closeButton">
          <img src={modalclose} alt="close" onClick={toggle} />
        </div>
      </div>
      <div className="modalBody">
        <div>
          <Label htmlFor="packageAmount">
            Enter No. of Packages<strong style={{ color: 'blue' }}>*</strong>
          </Label>
          <Input
            name="packages"
            autoComplete="off"
            value={number}
            type="number"
            onChange={(e) => setNumber(Number(e.target.value))}
            placeholder="Enter here"
            id="packageAmount"
          />
        </div>
        <div>
          <Label htmlFor="reason">
            Reason<strong style={{ color: 'blue' }}>*</strong>
          </Label>
          <select
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            id="reason"
            className="acceptReason"
            placeholder="Select"
          >
            <option value="Credit limit exceeded">Credit limit exceeded</option>
            <option value="Stock not available">Stock not available</option>
            <option value="Other">Other</option>
          </select>
        </div>
        {selectedOption === 'Other' && (
          <div>
            <Label htmlFor="packageAmount">
              Reason<strong style={{ color: 'blue' }}>*</strong>
            </Label>
            <Input
              name="reason"
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
              autoComplete="off"
              type="text"
              placeholder="Reason"
              id="reason"
            />
          </div>
        )}
      </div>

      <div className="modalBottom">
        <button
          className="customButton customButton_blue"
          onClick={() => {
            accept(
              number,
              selectedOption === 'Other' ? otherReason : selectedOption,
            );
          }}
        >
          Submit
        </button>
      </div>
    </Modal>
  );
};

export default PartiallyAcceptOrderConfirmModal;
